import React from 'react';
import PanelHelpBadge from '../PanelHelpBadge';

const STATUS_COLOR_MAP = {
  normal: 'border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-700 dark:bg-emerald-900/20 dark:text-emerald-300',
  dikkat: 'border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-700 dark:bg-amber-900/20 dark:text-amber-300',
  risk: 'border-rose-200 bg-rose-50 text-rose-700 dark:border-rose-700 dark:bg-rose-900/20 dark:text-rose-300',
  critical: 'border-rose-200 bg-rose-50 text-rose-700 dark:border-rose-700 dark:bg-rose-900/20 dark:text-rose-300'
};

function Badge({ label, value, tone }) {
  const colorClass = STATUS_COLOR_MAP[tone] || 'border-slate-200 bg-slate-50 text-slate-700 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-300';
  return (
    <span className={`inline-flex items-center gap-2 rounded-lg border px-3 py-1.5 text-xs font-semibold ${colorClass}`}>
      <span>{label}</span>
      <span className="font-black">{value}</span>
    </span>
  );
}

export default function SystemHealthStrip({ health }) {
  const status = String(health?.status || 'bilinmiyor').toLowerCase();
  const alertCount = Number(health?.alertCount || 0);

  return (
    <section className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-[#101922]">
      <div className="mb-3 flex items-center gap-2">
        <h3 className="text-sm font-black text-slate-900 dark:text-white">Sistem Sağlığı</h3>
        <PanelHelpBadge
          title="Sistem Sağlığı"
          description="Veri akışının tazeliğini ve operasyon alarm seviyesini hızlıca gösterir."
          interpretation="Dikkat veya risk durumunda önce ilgili kartın detayına in."
          metricExample="Drop oranı yükselirken event gecikmesi artıyorsa veri boru hattında sorun olabilir."
        />
      </div>
      <div className="flex flex-wrap gap-2 overflow-x-auto pb-1">
        <Badge label="Durum" value={status.toUpperCase()} tone={status} />
        <Badge label="Event Gecikmesi" value={`${Number(health?.eventLagSeconds || 0).toLocaleString('tr-TR')} sn`} tone={status} />
        <Badge label="Drop Oranı" value={`${Number(health?.dropRatePct || 0).toLocaleString('tr-TR')}%`} tone={status} />
        <Badge label="Alarm" value={alertCount.toLocaleString('tr-TR')} tone={alertCount > 0 ? 'dikkat' : 'normal'} />
      </div>
    </section>
  );
}
